import { ChangeDetectorRef, ElementRef } from '@angular/core';
import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChange,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import {
    AbstractControl,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { DoctorService } from 'app/modules/doctor/services/doctor.service';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { User } from '../model/User';
import { RolesComponent } from '../roles/roles.component';
import { UserManagementViewService } from '../services/user-management-view.service';
import { UserManagementService } from '../services/user-management.service';
import { AddEditCompanyComponent } from './add-edit-company/add-edit-company.component';
import { ControlDeAccesosComponent } from './control-de-accesos/control-de-accesos.component';
import { RolesPopupComponent } from './roles-popup/roles-popup.component';
import { DireccionService } from 'app/modules/employee-view/services/direccion.service';
import Utils from 'app/Utils';
import { GruposEmpresaService } from 'app/modules/grupos-empresa/services/grupos-empresa.service';

@Component({
    selector: 'app-users-details',
    templateUrl: './users-details.component.html',
    styleUrls: ['./users-details.component.scss'],
    standalone: false
})
export class UsersDetailsComponent implements OnInit, OnChanges {
    @Input() user: User;
    @ViewChild('medicoSelect')doctorSearchInput :ElementRef
    _medicoList :any=[];
    private userBackUp: User;
    public userForm: UntypedFormGroup;
    private usersList: User[];
    public companyList: any;
    public userRolesList: any;
    private emailPattern: string =
        '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';

    public coordinatorList: any; //IDropDown<string>[];
    public activeDoctorList: any; //IDropDown<string>[];
    public mainRoleList: any;
    public permissionList: Array<string>;

    public gruposEmpresaList: any[] = [];
    public empresasGrupoSeleccionado: any[] = [];
    public grupoEmpresaSeleccionado: any = null;

    public gruposEmpresaSeleccionados: any[] = [];
    public gruposEmpresaSeleccionadosNombre: string = '';

    @ViewChild('grupoEmpresaSelect') grupoEmpresaSearchInput: ElementRef;

    public filteredGruposEmpresaList: any[] = [];

    constructor(
        private _dialog: MatDialog,
        private _fb: UntypedFormBuilder,
        private cdr: ChangeDetectorRef,
        private _userManagementService: UserManagementService,
        private _doctorService: DoctorService,
        private _selectionService: SelectionGenericService,
        public direccionService: DireccionService,
        private _sharedService: SharedService,
        public _viewService: UserManagementViewService,
        private _fileExportService: FileExportService,
        private _pageLoaderService: PageLoaderService,
        private gruposEmpresaService: GruposEmpresaService,
    ) {
        //set visiblity for the buttons and panels with default values
        _viewService.setView();
        _viewService.getTipoList();
        this.initUserForm();
        this.getUsersList();
        this.getMainRolePrincipals();
        this.getCoordinatorsList();
        this.getCommonDoctorsList();

        this._userManagementService.clickedAddNewUser$.subscribe(() => {
            _viewService.setView(false, true, true, false, true, false);
            this.companyList = null;
            this.userRolesList = null;
            this.user = new User();
            this.userBackUp = new User();
            this.userForm.enable();
            this.userForm.reset();
            this.getUsersList();
        });
    }

    ngOnInit(): void {
        const currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        if (currentUser) {
            this.permissionList =
                this._sharedService.getCurrentUserPermissions();
        }
    }

    public checkPermission(permissionId: string): boolean {
        return this.permissionList.includes(permissionId);
    }

    private initUserForm() {
        this.userForm = this._fb.group({
            usuarioId: [{ value: null, disabled: true }],
            abreviacion: [{ value: null, disabled: true }, Validators.required],
            nombre: [{ value: null, disabled: true }, Validators.required],
            medicoId: [{ value: null, disabled: true }],
            coordinador: [{ value: null, disabled: true }],
            email: [
                { value: null, disabled: true },
                Validators.pattern(this.emailPattern),
            ],
            telefono: [{ value: null, disabled: true }],
            verTodosMedicos: [{ value: null, disabled: true }],
            verTodosCoordinadores: [{ value: null, disabled: true }],
            gestor: [{ value: null, disabled: true }],
            due: [{ value: null, disabled: true }],
            rolId: [{ value: null, disabled: true }],
            provincia: [{ value: null, disabled: true }],
            grupoEmpresaId: [{ value: [], disabled: true }],
            observaciones: [{ value: null, disabled: true }],
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!changes['user'].firstChange) {
            //get changed user
            this.user = changes['user'].currentValue;
            //get user backup
            this.userBackUp = { ...this.user };
            //update form
            this.userForm.patchValue({
                ...this.user,
                grupoEmpresaId: this.normalizeGrupoEmpresaValue(this.user?.carteraEmpresas)
            });

            this.getGruposEmpresa();

            this.cdr.detectChanges();
            //get relevant user companies es
            this.getUserCompanies(this.user.abreviacion);
            this.getUserRoles(this.user.abreviacion);
            this._viewService.setView(true, false, false, true, true, false);
            this.userForm.disable();
        }
    }
    SearchDoctors()
    {
        const searchInput=this.doctorSearchInput.nativeElement.value ?
        this.doctorSearchInput.nativeElement.value.toLowerCase():'';

        this._medicoList =this.activeDoctorList.filter(m=>{
            if(m.viewValue!=null)
            {
                const viewValue : string=m.viewValue.toLowerCase();
                return viewValue.indexOf(searchInput) > -1;
            }
        }) 
    }

    public onChangeGrupoEmpresa(): void {
        const ctrl = this.userForm.get('grupoEmpresaId');
        const rawValue = ctrl?.value;

        const selectedIds = this.normalizeGrupoEmpresaValue(rawValue);

        // importante: dejar siempre el control como array
        ctrl?.setValue(selectedIds, { emitEvent: false });

        if (!selectedIds.length) {
            this.gruposEmpresaSeleccionados = [];
            this.gruposEmpresaSeleccionadosNombre = '';
            this.empresasGrupoSeleccionado = [];
            return;
        }

        this.gruposEmpresaSeleccionados = this.gruposEmpresaList.filter(grupo =>
            selectedIds.includes(Number(grupo.grupoId))
        );

        this.gruposEmpresaSeleccionadosNombre = this.gruposEmpresaSeleccionados
            .map(g => g.nombre)
            .filter(Boolean)
            .join(', ');

        const empresasMap = new Map<string, any>();

        this.gruposEmpresaSeleccionados.forEach(grupo => {
            (grupo?.empresas || []).forEach((empresa: any) => {
                const key = String(empresa?.empresaId ?? empresa?.id ?? empresa?.nombre);
                if (!empresasMap.has(key) && empresa?.nombre) {
                    empresasMap.set(key, empresa);
                }
            });
        });

        this.empresasGrupoSeleccionado = Array.from(empresasMap.values());
    }

    private getGruposEmpresa(): void {
        this.gruposEmpresaService.getGrupos().subscribe(
            (response: any) => {
                this.gruposEmpresaList = response?.result || [];
                this.filteredGruposEmpresaList = [...this.gruposEmpresaList];
                this.onChangeGrupoEmpresa();
            },
            (error) => {
                console.error('Error al cargar grupos de empresa', error);
                this.gruposEmpresaList = [];
                this.filteredGruposEmpresaList = [];
                this.grupoEmpresaSeleccionado = null;
                this.empresasGrupoSeleccionado = [];
            }
        );
    }

    public searchGruposEmpresa(): void {
        const term = this.grupoEmpresaSearchInput?.nativeElement?.value
            ? this.grupoEmpresaSearchInput.nativeElement.value.toLowerCase()
            : '';

        this.filteredGruposEmpresaList = this.gruposEmpresaList.filter(grupo => {
            const nombre = (grupo?.nombre || '').toLowerCase();
            return nombre.includes(term);
        });
    }

    public submit() {
        this.userForm.markAllAsTouched();
        this.userForm.updateValueAndValidity();

        const formValue = this.userForm.getRawValue();

        if (
            this.usersList.find((t) => t['abreviacion'] === formValue.abreviacion) &&
            !(formValue.abreviacion == this.user.abreviacion)
        ) {
            this._sharedService.ShowSnackBar('El identificador ya existe.');
        } else {
            if (this.userForm.valid) {
                const selectedGrupoIds = this.normalizeGrupoEmpresaValue(formValue.grupoEmpresaId);

                const payload: User = {
                    ...this.user,
                    ...formValue,
                    carteraEmpresas: selectedGrupoIds.length
                        ? selectedGrupoIds.join('*')
                        : null
                } as any;

                if (formValue.usuarioId == null) {
                    this.user = payload;
                    this.userBackUp = this.user;
                    this.getUserCompanies(this.user.abreviacion);
                    this.user.usuarioId = 0;
                    this.addUser(this.user);
                } else {
                    this.user = payload;
                    this.updateUser(this.user);
                }
            }
        }
    }

    public addUserRole(): void {
        const modalRef = this._dialog.open(RolesPopupComponent, {
            data: { userAbriviation: this.user.abreviacion },
        });
        modalRef.afterClosed().subscribe((responce) => {
            if (responce) {
                this.getUserRoles(this.user.abreviacion);
            }
        });
    }

    public addNewRoles(): void {
        const modalRef = this._dialog.open(RolesComponent, {});
        modalRef.afterClosed().subscribe((responce) => {
            if (responce) {
            }
        });
    }

    public addCompany(): void {
        const modalRef = this._dialog.open(AddEditCompanyComponent, {
            data: { userAbriviation: this.user.abreviacion },
        });
        modalRef.afterClosed().subscribe((responce) => {
            if (responce) {
                this.getUserCompanies(this.user.abreviacion);
            }
        });
    }

    //#region User company
    public getUserCompanies(userAbriviation: any) {
        this._userManagementService
            .getUserCompanies(userAbriviation)
            .subscribe((response) => {
                try {
                    this.companyList = response.result.sort((a, b) => a.nombre.localeCompare(b.nombre));
                } catch (error) {
                    this.companyList = response.result;
                }
            });
    }

    public deleteCompany(userId: any, userAbriviation: string, index: number) {
        const dialogData = new ConfirmDialogModel(
            '¿Quitar la empresa al usuario?',
            ''
        );
        const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
            data: dialogData,
        });
        dialogRef.afterClosed().subscribe((response) => {
            if (response) {
                this._userManagementService
                    .deleteUserCompany(userId, userAbriviation)
                    .subscribe(
                        (result) => {
                            if (result) {
                                this.companyList.splice(index, 1);
                                this._sharedService.ShowSnackBar(
                                    'Borrado exitosamente',
                                    'Okay',
                                    2000
                                );
                            } else {
                                this._sharedService.ShowSnackBar(
                                    'Se produjo un error',
                                    'Okay',
                                    2000
                                );
                            }
                        },
                        (err) => {
                            console.error(err);
                            this._sharedService.ShowSnackBar(
                                'Se produjo un error',
                                'Okay',
                                2000
                            );
                        }
                    );
            }
        });
    }
    //#endregion

    //#region User API calls

    public getUsersList() {
        this._userManagementService.getUsersList().subscribe(
            (res) => {
                this.usersList = res.result;
            },
            (err) => {
                console.error(err);
            }
        );
    }

    public getMainRolePrincipals() {
        this._userManagementService
            .getMainRolePrincipals()
            .subscribe((response) => {
                this.mainRoleList = response.result;
            });
    }

    public getUserRoles(abreviacion: string) {
        this._userManagementService
            .getUserRoles(abreviacion)
            .subscribe((response) => {
                this.userRolesList = response.result;
            });
    }

    public deleteUserRole(userRolId: number, index: number) {
        this._userManagementService
            .deleteUserRole(userRolId, this.user.abreviacion)
            .subscribe(
                (result) => {
                    if (result) {
                        this.userRolesList.splice(index, 1);
                        this._sharedService.ShowSnackBar(
                            'Borrado exitosamente',
                            'Okay',
                            2000
                        );
                    } else {
                        this._sharedService.ShowSnackBar(
                            'Se produjo un error',
                            'Okay',
                            2000
                        );
                    }
                },
                (err) => {
                    console.error(err);
                    this._sharedService.ShowSnackBar(
                        'Se produjo un error',
                        'Okay',
                        2000
                    );
                }
            );
    }

    private getUesrById(userId: number) {
        this._userManagementService
            .getUserById(userId)
            .subscribe((response) => {
                this.user = response.result;
                this.userBackUp = { ...this.user };

                this.userForm.patchValue({
                    ...response.result,
                    grupoEmpresaId: this.normalizeGrupoEmpresaValue(response.result?.carteraEmpresas)
                });

                this.onChangeGrupoEmpresa();
            });
    }

    public addUser(user: User) {
        this._userManagementService.addUser(user).subscribe(
            (res) => {
                if (res.code === 0 && res.result) {
                    this.user = res.result;
                    this.userBackUp = this.user;
                    this.userForm.patchValue({
                        ...this.user,
                        grupoEmpresaId: this.normalizeGrupoEmpresaValue(this.user?.carteraEmpresas)
                    });                    
                    this.updateUserList();
                    this._sharedService.ShowSnackBar('Guardado con éxito');
                    this.moveFormToNonEditable();
                    this.onChangeGrupoEmpresa();
                    this.updateUserList();
                } else {
                    this._sharedService.ShowSnackBar('Error al crear');
                }
            },
            (err) => {
                this._sharedService.ShowSnackBar('Se produjo un error');
                console.error(err);
            }
        );
    }

    public updateUser(user: User) {
        this._userManagementService.updateUser(user).subscribe(
            (res) => {
                if (res.code === 0 && res.result === 1) {
                    this.updateUserList();
                    this.getUesrById(this.user.usuarioId);
                    this._sharedService.ShowSnackBar(
                        'Actualizado con éxito',
                        'Okay',
                        2000
                    );
                    this.moveFormToNonEditable();
                } else {
                    this._sharedService.ShowSnackBar(
                        'Error al guardar',
                        'Okay',
                        2000
                    );
                }
            },
            (err) => {
                this._sharedService.ShowSnackBar(
                    'Se produjo un error',
                    'Okay',
                    2000
                );
            }
        );
    }

    public deleteUser(userId: any) {
        const dialogData = new ConfirmDialogModel('¿Eliminar el usuario?', '');
        const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
            data: dialogData,
        });

        dialogRef.afterClosed().subscribe((response) => {
            if (response) {
                this._userManagementService.deleteUser(userId).subscribe(
                    (result) => {
                        if (result) {
                            this.resetUserPage();
                            this.updateUserList();
                            this._viewService.setView(
                                null,
                                false,
                                false,
                                null,
                                false,
                                null
                            );
                            this._sharedService.ShowSnackBar(
                                'Borrado exitosamente',
                                'Okay',
                                2000
                            );
                        } else {
                            this._sharedService.ShowSnackBar(
                                'Se produjo un error',
                                'Okay',
                                2000
                            );
                        }
                    },
                    (err) => {
                        console.error(err);
                        this._sharedService.ShowSnackBar(
                            'Se produjo un error',
                            'Okay',
                            2000
                        );
                    }
                );
            }
        });
    }

    private getCoordinatorsList() {
        this._selectionService.GetCoordinatorList().subscribe((res) => {
            this.coordinatorList = res.result;
        });
    }

    private getCommonDoctorsList() {
        this._doctorService.GetActiveDoctorsDropdown().subscribe((res) => {
            this.activeDoctorList = res;
            this._medicoList = res;
        });
    }

    //#endregion

    public convertToCapital(event: any, controlName: string) {
        if (controlName == 'abreviacion') {
            this.userForm.patchValue({
                abreviacion: event.target.value.toUpperCase(),
            });
        } else if (controlName == 'nombre') {
            this.userForm.patchValue({
                nombre: event.target.value.toUpperCase(),
            });
        }
    }

    public enableUserForm(): void {
        this._viewService.setView(false, true, true, true, null, true);
        this.userForm.enable();
    }

    public resetForm(): void {
        this._viewService.setView(true, false, false, null, null, false);
        this.userForm.disable();
        this.userForm.patchValue(this.userBackUp);

        //this scenario occur when you click the undo button in the create new user page
        if (!this._viewService.deleteBtn) {
            this._viewService.setView(false, false, false, null, false, null);
        }
    }

    /**
     * Move form to non editable form by removing some buttons and disabling the form
     */
    private moveFormToNonEditable() {
        this._viewService.setView(true, false, false, null, null, false);
        this.userForm.disable();
    }

    public getControlDeAccesosFile() {
        const modalRef = this._dialog.open(ControlDeAccesosComponent, {});
        modalRef.afterClosed().subscribe((responce) => {});
    }

    public getListadoDeUsuariosFileActivos() {
        this._pageLoaderService.ShowPageLoader();
        this._sharedService.ShowSnackBar(
            'El archivo se descargará en breve',
            'Okay',
            2000
        );
        this._userManagementService.getListadoDeUsuariosFileActivos().subscribe(
            (res) => {
                if (
                    res.code === 0 &&
                    res.result.file !== null &&
                    res.result.file !== undefined
                ) {
                    this._fileExportService.DownloadFile(
                        res.result.file,
                        res.result.fileName
                    );
                } else {
                    this._sharedService.ShowSnackBar(
                        'Proceso fallido',
                        'Okay',
                        2000
                    );
                }
                this._pageLoaderService.HidePageLoader();
            },
            (error) => {
                this._sharedService.ShowSnackBar('Proceso fallido');
                console.error(error);
                this._pageLoaderService.HidePageLoader();
            }
        );
    }

    public getListadoDeUsuariosFileInactivos() {
        this._pageLoaderService.ShowPageLoader();
        this._sharedService.ShowSnackBar(
            'El archivo se descargará en breve',
            'Okay',
            2000
        );
        this._userManagementService.getListadoDeUsuariosFileInactivos().subscribe(
            (res) => {
                if (
                    res.code === 0 &&
                    res.result.file !== null &&
                    res.result.file !== undefined
                ) {
                    this._fileExportService.DownloadFile(
                        res.result.file,
                        res.result.fileName
                    );
                } else {
                    this._sharedService.ShowSnackBar(
                        'Proceso fallido',
                        'Okay',
                        2000
                    );
                }
                this._pageLoaderService.HidePageLoader();
            },
            (error) => {
                this._sharedService.ShowSnackBar('Proceso fallido');
                console.error(error);
                this._pageLoaderService.HidePageLoader();
            }
        );
    }

    private updateUserList() {
        this._userManagementService.updateUserList$.next();
    }

    private resetUserPage() {
        this._userManagementService.clickedAddNewUser$.next();
    }

    private normalizeGrupoEmpresaValue(value: any): number[] {
        if (!value) {
            return [];
        }

        if (Array.isArray(value)) {
            return value
                .map(v => Number(v))
                .filter(v => !isNaN(v));
        }

        if (typeof value === 'string') {
            return value
                .split('*')
                .map(v => Number(v.trim()))
                .filter(v => !isNaN(v));
        }

        const numericValue = Number(value);
        return isNaN(numericValue) ? [] : [numericValue];
    }
}
